
  <div class="col-md-12 mb-1">
    <div class="mb-3"><h4>Application form - Offer to sell credits to the BCT</h4></div>
    <form [formGroup]="creditOfferFg" novalidate>
      <div class="card mt-2">
        <div class="card-body">
          <div class="col col-md-12">

            <div class="row">
              <div class="form-group col col-md-6 col-xs-6"><span *ngIf="!allowOffers" class="text-danger ml-3">BCT is not accepting any offers at the moment.</span></div>
            </div>
            <div class="row">
              <div class="form-group col col-md-6 col-xs-6">
                <label class="control-label">Credit purchase method: </label><span class="ml-2">{{deliveryMechamismName}}</span>
              </div>
            </div>
            <div class="row">
              <div class="form-group col col-md-6 col-xs-6">
                <label class="control-label">Credit purchase program: </label><span class="ml-2">{{programName}}</span>
            
              </div>
            </div>
            <!--<div *ngIf="deliveryMechanisms?.length>1" class="row">
              <div class="form-group col col-md-6 col-xs-6">
                <label class="control-label required" for="deliveryMechanism">Credit purchase method</label>
                <select id="deliveryMechanism" formControlName="deliveryMechanism" class="form-control col-sm-6">
                  <option value="">Select a Credit purchase method</option>
                  <option *ngFor="let dm of deliveryMechanisms" value="{{dm?.code}}" selected>{{dm?.name}}</option>
                </select>
                <div class="text-danger" [hidden]="creditOfferFg.controls.deliveryMechanism.valid || !creditOfferFg.controls.deliveryMechanism.touched">
                  <small *ngIf="creditOfferFg.controls.deliveryMechanism.hasError('required')">Credit purchase method is required.</small>
                </div>
              </div>
            </div>-->
           
            <div class="row">
              <div class="col col-md-10 col-xs-8">
                <p>
                  Use this form to apply to sell biodiversity credits to the BCT.

                </p>
                <p>
                  Information on how to sell credits to the BCT can be found in the participants guide for the biodiversity credit tender or open fixed price offer program.
                </p>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="card mt-2">
        <div id="generalInfoHeadingDiv" class="pointer" role="button" (click)="toggleCollapse(0);" data-toggle="collapse"
             data-target="#generalInfoDiv" aria-expanded="true" aria-hidden="true" aria-controls="generalInfoDiv" appAccordionDefaultOpenIcons>
          <h4 class="card-header accordion-up">General information <span class="pull-right mr-3"><i class="fa fa-arrow-up icon-info" aria-hidden="true"></i></span></h4>
        </div>
        <div id="generalInfoDiv" [ngbCollapse]="isCollapsed(0)">
          <div class="card-body">
            <div class="col col-md-6">
              <div class="form-group col col-md-6 col-xs-6">
                <label class="control-label required" for="subRegion">IBRA Subregion</label>
                <select id="subRegion" formControlName="subRegion" class="form-control col-xs-6">
                  <option value="">Select IBRA Subregion</option>
                  <option *ngFor="let sr of subRegions" value="{{sr.id}}">{{sr.name}}</option>
                </select>
              </div>
              <div class="form-group col col-md-6 col-xs-6">
                <label class="control-label" for="agreementStatus">Agreement Status</label>
                <select id="agreementStatus" formControlName="agreementStatus" class="form-control col-xs-6" (change)="agreementChanged($event);">
                  <option value="" selected>Select agreement status</option>
                  <option value="E">Existing</option>
                  <option value="P">Proposed</option>
                </select>
              </div>
              <div class="form-group col col-md-6 col-xs-6">
                <label class="control-label" for="agreementNumber">Agreement ID<span class="small">&nbsp;(for existing biobank or BSA site)</span></label>
                <input id="agreementNumber" formControlName="agreementNumber" title="Agreement Number" type="text"
                       maxlength="25" class="form-control col-xs-6" placeholder="Agreement Number" aria-required="true" />
              </div>
              <div *ngIf="!schemeReadOnly" class="form-group col col-md-6 col-xs-6">
                <label class="control-label" for="offsetScheme">Offset Scheme Credit Type</label>
                <select id="offsetScheme" formControlName="offsetScheme" class="form-control" (change)="schemeChanged($event);" [disabled]= "schemeReadOnly">
                  <option value="" selected>Select offset scheme</option>
                  <option value="BAM">BAM</option>
                  <option value="BBAM">BBAM</option>
                </select>
              </div>
              <div *ngIf="!schemeReadOnly" class="form-group col col-md-6 col-xs-6">
                <label class="control-label" for="creditStatus">Status of Credits Offered for Sale</label>
                <select id="creditStatus" formControlName="creditStatus" class="form-control" [disabled]= "schemeReadOnly">
                  <option value="" selected>Select credit status</option>
                  <option value="E">Existing</option>
                  <option value="P">Proposed</option>
                </select>
              </div>

              <div *ngIf="schemeReadOnly" class="form-group col col-md-6 col-xs-6">
                <label class="control-label" for="offsetScheme">Offset Scheme Credit Type: </label><span class="ml-2">BAM</span>
                <label class="control-label" for="offsetScheme">Status of Credits Offered for Sale: </label><span class="ml-2">Proposed</span>
              </div>

            </div>
            <div class="row">
              <div class="form-group col col-md-12 col-xs-6">
                <p>Note:  All credits included in this application must be from the same site, be created through the same scheme (ie BBAM or BAM credits) and have the same status (existing or proposed credits). </p>
              </div>

            </div>
          </div>
        </div>
      </div>

      <!--credit holder details-->
      <div *ngIf="showOwnerDetails" class="card mt-2">
        <div class="pointer" role="button" (click)="toggleCollapse(1);" data-toggle="collapse"
             data-target="#creditholderDiv" aria-expanded="true" aria-hidden="true" aria-controls="generalInfoDiv" appAccordionDefaultOpenIcons>
          <h4 class="card-header accordion-up">
            Credit owner details<span class="pull-right mr-3"><i class="fa fa-arrow-up icon-info" aria-hidden="true"></i></span>
          </h4>
        </div>
        <div id="creditholderDiv" [ngbCollapse]="isCollapsed(1)">
          <div class="card-body">
            <div class="row">
              <div class="col">
                <p>This section is to be completed by owners of existing credits.</p>
                <p>The Applicant is the credit owner as identified on Credit ownership report.</p>
                <p>Proceed to 'Landholder details' section below if you are a landholder proposing to establish a BSA.</p>
              </div>
            </div>
            <div class="row">
              <div class="form-group col col-md-6 col-xs-6">
                <label class="control-label" for="creditOwners">Applicant Name <span class="small">(Credit owner name as identified on credit ownership report)</span></label>
                <textarea id="creditOwners" formControlName="creditOwners" rows="3" title="Credit Owners" type="text" maxlength="250"
                          class="form-control col-sm-6" placeholder="Credit owners" aria-required="true"></textarea>

              </div>
            </div>
            <div class="row">
              <div class="form-group col col-md-6 col-xs-6">
                <label class="control-label" for="lastName">BOAMS Number</label>
                <input id="boamsNumber" formControlName="boamsNumber" title="BOAMS Number" type="text" maxlength="25"
                       class="form-control col-sm-6" placeholder="BOAMS Number" aria-required="true" />

              </div>
            </div>
            <div class="row">
              <!--<div class="col form-group col-sm-6 col-md-6">-->
              <!--<div class="row">-->
              <div class="form-group col col-md-6 col-xs-6">
                <label class="control-label" for="creditOwnerId">Credit Owner Id</label>&nbsp;<span class="small">(Enter either BAM Credit Holding ID or BBAM Credit Owner ID)</span>
                <input id="creditOwnerId" formControlName="creditOwnerId" title="Credit owner Id" type="text"
                       maxlength="15" class="form-control col-sm-6" placeholder="Credit owner Id" aria-required="true" />
              </div>

              <!--</div>-->
              <!--</div>-->

            </div>


          </div>
        </div>
      </div>

      <!--LandHolder details-->
      <div *ngIf="showLandholderDetails" class="card mt-2">
        <div data-toggle="collapse" class="pointer" data-target="#landholderDetailsDiv" role="button" (click)="toggleCollapse(2);"
             aria-expanded="false" aria-controls="landholderDetailsDiv" aria-hidden="true" appAccordionDefaultOpenIcons>
          <h4 class="card-header accordion-up">
            Landholder details<span class="pull-right mr-3">
              <i class="fa fa-arrow-up icon-info" aria-hidden="true">
              </i>
            </span>
          </h4>
        </div>
        <div id="landholderDetailsDiv" [ngbCollapse]="isCollapsed(2)">
          <div class="col md-12 clearfix py-3">
            <div class="card-body">
              <div class="row">
                <div class="col col-sm-6 col-md-6">
                  <p>This section is to be completed by landholders proposing to establish a BSA.</p>
                  <p>The Applicant is the landholder, as identified on land title.</p>
                </div>

              </div>
              <div class="row">
                <div class="col col-sm-6 col-md-6">
                  <div class="row">
                    <div class="form-group col col-md-6 col-xs-6">
                      <label class="control-label" for="firstName">Applicant Name<span class="small">(ie landholder name as identified on land title)</span></label>
                      <textarea id="applicantName" formControlName="applicantName" title="Applicant Name" maxlength="250"
                                class="form-control" placeholder="Applicant Name" aria-required="true">
                    </textarea>

                    </div>
                  </div>
                  <div class="row col">
                    <h5>Property address <span class="small">(Property for proposed BSA)</span></h5>
                  </div>
                  <div class="row">
                    <div class="form-group col col-md-6 col-xs-6">
                      <label class="control-label" for="address1">Address 1</label>
                      <input id="address1" formControlName="address1" title="address 1" type="text" maxlength="50"
                             class="form-control" placeholder="Address 1" aria-required="true" autocomplete="off" />
                    </div>
                  </div>
                  <div class="row">
                    <div class="form-group col col-md-6 col-xs-6">
                      <label class="control-label" for="address2">Address 2</label>
                      <input id="address2" formControlName="address2" title="address 2" type="text" maxlength="50"
                             class="form-control " placeholder="Address 2" aria-required="true" autocomplete="off" />
                    </div>
                  </div>

                  <div class="row">
                    <div class="form-group col col-md-6 col-xs-6">
                      <label class="control-label" for="suburb">Town/Suburb</label>
                      <input id="suburb" formControlName="suburb" title="suburb" type="text" maxlength="50"
                             class="form-control " placeholder="Suburb" aria-required="true" autocomplete="off" />
                    </div>
                  </div>

                  <div class="row">
                    <div class="form-group col col-md-6 col-xs-6">
                      <label class="control-label" for="state">State/Territory</label>
                      <select id="state" formControlName="state" class="form-control">
                        <option value="" selected>Select state</option>
                        <option value="nsw">New South Wales</option>

                      </select>
                    </div>
                  </div>
                  <div class="row">
                    <div class="form-group col col-md-6 col-xs-6">
                      <label class="control-label" for="postCode">Postcode</label>
                      <input id="postCode" formControlName="postCode" title="postcode" type="text" maxlength="5"
                             class="form-control " placeholder="postcode" aria-required="true" autocomplete="off" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
      <!--Applicant details-->
      <div class="card mt-2">
        <div data-toggle="collapse" class="pointer" data-target="#applicantDetailsDiv" role="button" (click)="toggleCollapse(3);" aria-expanded="false"
             aria-controls="applicantDetailsDiv" aria-hidden="true" appAccordionDefaultOpenIcons>
          <h4 class="card-header accordion-up">Contact details<span class="pull-right mr-3"><i class="fa fa-arrow-up icon-info" aria-hidden="true"></i></span></h4>

        </div>
        <div id="applicantDetailsDiv" [ngbCollapse]="isCollapsed(3)">
          <div class="col md-6 clearfix">
            <div class="card-body">
              <div class="row">
                <div class="col-6">
                  <app-contact-details #primaryContact [title]="'Primary contact'" [isRequired]="true"></app-contact-details>
                </div>
                <div class="col-6">
                  <app-contact-details #secondaryContact [title]="'Secondary contact'" [isRequired]="false"></app-contact-details>
                </div>
              </div>
              <!--<div class="row">
                <div class="form-group col col-md-6 col-xs-6">
                  <label class="control-label required" for="contactName">First Name</label>
                  <input id="contactName" formControlName="contactName" title="Contact Name" type="text" maxlength="51"
                         class="form-control" placeholder="Contact name" aria-required="true" />
                  <div class="text-danger" [hidden]="creditOfferFg.controls.contactName.valid || !creditOfferFg.controls.contactName.touched">
                    <small *ngIf="creditOfferFg.controls.contactName.hasError('required')">Contact first name is required.</small>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="form-group col col-md-6 col-xs-6">
                  <label class="control-label required" for="contactLastName">Last Name</label>
                  <input id="contactLastName" formControlName="contactLastName" title="Contact Last Name" type="text" maxlength="51"
                         class="form-control" placeholder="Contact Last name" aria-required="true" />
                  <div class="text-danger" [hidden]="creditOfferFg.controls.contactLastName.valid || !creditOfferFg.controls.contactLastName.touched">
                    <small *ngIf="creditOfferFg.controls.contactLastName.hasError('required')">Contact last name is required.</small>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="form-group col col-md-6 col-xs-6">
                  <label class="control-label required" for="email">Email</label>
                  <input id="email" formControlName="email" title="Email" type="text" maxlength="100" class="form-control"
                         placeholder="Email" aria-required="true" />
                  <div class="text-danger" [hidden]="creditOfferFg.controls.email.valid || !creditOfferFg.controls.email.touched">
                    <small *ngIf="creditOfferFg.controls.email.hasError('required')">Email is required.</small>
                    <small *ngIf="creditOfferFg.controls.email.hasError('email')">Email is invalid.</small>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="form-group col col-md-6 col-xs-6">
                  <label class="control-label" for="contactPhone">Phone</label>
                  <input id="contactPhone" formControlName="contactPhone" title="phone" type="text" maxlength="15"
                         class="form-control" placeholder="Phone" aria-required="true" />

                </div>
              </div>-->
            </div>
          </div>
        </div>
      </div>

    
    <!--Wanted Credits-->
    <div class="card mt-2">
      <div data-toggle="collapse" class="pointer" data-target="#wantedCreditsDiv" role="button" (click)="toggleCollapse(4);"  aria-expanded="false"
           aria-controls="wantedCreditsDiv" aria-hidden="true" appAccordionDefaultOpenIcons>
        <h4 class="card-header accordion-up">
          Credits offered for sale<span class="pull-right mr-3">
            <i class="fa fa-arrow-up icon-info" aria-hidden="true">
            </i>
          </span>
        </h4>
      </div>
      <div id="wantedCreditsDiv" [ngbCollapse]="isCollapsed(4)">

        <div class="col md-12 clearfix py-3">
          <div class="card-body">
            <div class="row">
              <div class="col col-md-12 col-xs-6">
                <p>
                  If you own BBAM credits, then enter information for the BAM-equivalent credits from the statement of reasonable credit equivalence.
                </p>
                <p>
                  For landholders, expected BAM credit information will be provided in your feasibility assessment, business case or draft BSSAR.
                </p>
              </div>
            </div>
            <form [formGroup]="creditOfferSaleFgDetails">
              <div>
                <div>
                  <ul>
                    <li class="text-danger" *ngFor="let err of validationErrors">{{err}}</li>
                  </ul>
                </div>
                <table class="table">
                  <thead>
                    <tr class="thead-light">
                      <th colspan="2" class="align-text-top" nowrap>Credit Type ID</th>
                      <th class="align-text-top" nowrap *ngIf="isExistingCredit">DPIE Credit ID</th>
                      <th class="align-text-top" nowrap>Credit Category</th>
                      <th class="align-text-top" nowrap>Offset Trading Group</th>
                      <th class="align-text-top">Hollow-Bearing<br /> Tree status</th>
                      <th class="align-text-top">Credits Offered</th>
                      <th class="align-text-top">Credits Wanted</th>
                      <th class="align-text-top" *ngIf="showBidPrice">Price per BAM Credit <br /><span class="small">(Exc. GST)</span></th>
                      <th class="align-text-top" *ngIf="showBidPrice">Total Price<br /> <span class="small">(Exc. GST)</span></th>
                    </tr>
                  </thead>
                  <tbody *ngIf="wantedCredits?.length>0" formGroupName="creditsGroup">
                    <tr *ngFor="let credit of wantedCredits;let i=index" [formGroupName]="i">
                      <td>
                        <button class="btn btn-secondary btn-sm" (click)="deleteWantedCredit(credit,$event);" title="Delete Credit">
                          <i class="fa fa-trash"></i>
                        </button>
                      </td>
                      <td>{{credit.creditId}}</td>
                      <td *ngIf="isExistingCredit"><input class="form-control col-sm-6" type="text" formControlName="dpieCreditId"></td>
                      <td>{{credit.creditCategory}}</td>
                      <td>{{credit.creditCategory =='Species'?credit.name:credit.offsetTradingGroup}}</td>
                      <td>{{credit.creditCategory =='Species' ? "" : (credit.hbt ==true?'Yes':'No')}}</td>
                      <td><input class="form-control col-sm-8" min="1" max="{{credit.numberOfCredits}}" type="text" value="credit.numberOfCredits" formControlName="numberOfCredits" (change)="ValidateNumberOfCredits(i);" maxlength="5" /></td>
                      <td>{{credit.numberOfCredits}}</td>
                      <td *ngIf="showBidPrice"><input class="form-control col-sm-8" type="text" formControlName="bidPrice" (change)="calculateTotalPrice(i);" /></td>
                      <td *ngIf="showBidPrice">{{credit.totalBidPrice|currency}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div style="text-align: center;">
                <span *ngIf="wantedCredits?.length===0" class="text-info font-weight-bold">No credits found</span>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!--Offer Files-->
    <div class="card mt-2">
      <div data-toggle="collapse" class="pointer" data-target="#offerFilesDiv" role="button" (click)="toggleCollapse(5);" aria-expanded="false"
           aria-controls="offerFilesDiv" aria-hidden="true" appAccordionDefaultOpenIcons>
        <h4 class="card-header accordion-up">
          Supporting information<span class="pull-right mr-3">
            <i class="fa fa-arrow-up icon-info" aria-hidden="true">
            </i>
          </span>
        </h4>
      </div>
      <div id="offerFilesDiv" [ngbCollapse]="isCollapsed(5)">
        <div class="col md-12 clearfix py-3">
          <div class="card-body">
            <div>
              <p>Refer to the Open FPO or tender participants guide for information on the documents that you are required to submit with your application.</p>
            </div>
            <form [formGroup]="fgFiles" enctype="multipart/form-data" novalidate>
              <div class="row">
                <div class="col form-group col-sm-6 col-md-6">
                  <label class="control-label required" for="fileType">File Type</label>
                  <select id="fileType" formControlName="fileType" class="form-control">
                    <option value="" selected>Select file type</option>
                    <ng-container *ngFor="let type of filteredFileTypes">
                      <option value="{{type?.id}}">{{ type?.name }}</option>
                    </ng-container>
                  </select>
                  <div class="text-danger" [hidden]="fgFiles.controls.fileType.valid || !fgFiles.controls.fileType.touched">
                    <small *ngIf="fgFiles.controls.fileType.hasError('required')">File Type is required.</small>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col form-group col-sm-6 col-md-6">
                  <!--<app-upload-documents (uploadedFile)="selectedFile($event)"></app-upload-documents>-->
                  <label class="control-label required" for="file">File</label>&nbsp;<span class="small">Max file upload limit is 15 MB</span>
                  <input id="uploadDocuments" class="form-control iconPointer"
                         style="font-size: 11px;" type="file" name="file" (change)="selectDocument($event)">
                  <div class="text-danger" [hidden]="fgFiles.controls.file.valid || !fgFiles.controls.file.touched">
                    <small *ngIf="fgFiles.controls.file.hasError('required')">File is required.</small>
                  </div>
                  <div class="text-danger" *ngIf="fileError!=''"><small>{{fileError}}</small></div>
                </div>
              </div>
              <div class="row">
                <div class="col form-group col-sm-6 col-md-6">
                  <button class="btn btn-primary" [disabled]="!fgFiles.valid || !allowOffers" (click)="AddFile()">Upload</button>
                </div>
                <div class="col-md-12 col-sm-12">
                  <hr>
                </div>
              </div>
              <div class="row">
                <div class="col form-group col-md-12 col-sm-12">
                  <table class="table">
                    <thead>
                      <tr class="thead-light">
                        <th nowrap>Delete</th>
                        <th nowrap>File Name</th>
                        <th nowrap>File Type</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let file of files;let i=index">
                        <td>
                          <button class="btn btn-secondary btn-sm" (click)="deleteFile(file);" title="Delete File">
                            <i class="fa fa-trash"></i>
                          </button>
                        </td>
                        <td>{{file.fileName}}</td>
                        <td>{{getFileType(file.FileTypeId)}}</td>
                      </tr>
                    </tbody>
                  </table>
                  <div style="text-align: center;">
                    <span *ngIf="files?.length===0" class="text-info font-weight-bold">No files found</span>
                  </div>
                </div>
              </div>

            </form>
          </div>
        </div>
      </div>
    </div>

    <!--Declaration-->
    <div class="card mt-2">
      <div data-toggle="collapse" class="pointer" data-target="#declarationDiv" role="button" (click)="toggleCollapse(6);" aria-expanded="false"
           aria-controls="declarationDiv" aria-hidden="true" appAccordionDefaultOpenIcons>
        <h4 class="card-header accordion-up">
          Declaration<span class="pull-right mr-3">
            <i class="fa fa-arrow-up icon-info" aria-hidden="true">
            </i>
          </span>
        </h4>
      </div>
      <div id="declarationDiv" [ngbCollapse]="isCollapsed(6)">
        <div class="col md-12 clearfix py-3">
          <div class="card-body">
            <form [formGroup]="declarationFgDetails" novalidate class="row">
              <p class="ml-3 mr-3">
                I declare that, to the best of my knowledge:
              </p>
              <ul class="ml-4">
                <li>
                  the credits identified in this application are available for purchase by the BCT. If I am a landholder proposing a BSA then, to the best of my knowledge, these credits will be available for purchase when the BSA is established.
                </li>
                <li>
                  I have read the Participants Guide for the BCT credit purchase program.
                </li>
                <li>
                  all eligibility requirements to apply for the credit purchase program, as identified in the participants guide, are addressed.
                </li>
                <li>
                  I have prepared my application based on my own research and independent advice, and I have not relied upon any representations made by BCT staff.
                </li>
                <li>
                  where the credit owner or landholder is an organization or comprises of more than one entity, I have authority to complete this form on behalf of the organization or, if more than one entity, on behalf of all entities and
                </li>
                <li>
                  the information provided on this form is complete and correct.
                </li>

              </ul>
              <p class="ml-3 mr-3">
                I agree and acknowledge that:
              </p>
              <ul class="ml-4">
                <li>
                  <p>
                    I give permission for the BCT to collect, store and use personal information contained in
                    this application in accordance with the <a href="#" (click)="openPrivacy($event);">privacy notice and application details</a> and for the purpose of
                    assessing the application and purchasing the credits.
                  </p>

                </li>
                <li>
                  <p>
                    I give permission for the BCT to access, store and use any information that is held by the Department of Planning, Industry and Environment (DPIE) and the BCT,
                    in accordance with the <a href="#" (click)="openPrivacy($event);">privacy notice and application details</a> and for the purpose of assessing the application and purchasing the credits. This includes information to verify the ownership
                    and attributes of the credits that are the subject of this application, as well as attributes of the agreement that created the credits,
                    including information on the Total Fund Deposit for the agreement.
                  </p>

                </li>
                <li>
                  <p>
                    I acknowledge that the BCT has the right to revoke its acceptance of my application if it is discovered that any statement made by me in this form is incorrect,
                    incomplete or misleading, in a way that may have affected the decision to commit to purchase my biodiversity credits.
                  </p>
                </li>
                <li>
                  <p>I acknowledge that I have the right to decline an offer by the BCT to purchase my biodiversity credits, based on this application.</p>
                </li>
              </ul>
              <div class="row ml-3">
                <div class="form-group col-md-12 col-xs-10">
                  <input type="checkbox" class="form-check-input" (change)="consentChanged($event);" />&nbsp;<label class="form-check-label required">I confirm that I have read and consent to the above declarations (box to be checked to indicate consent).</label>
                  <br />
                  <input type="checkbox" class="form-check-input" (change)="consent2Changed($event);" />&nbsp;<label class="form-check-label required">I confirm that I have read and acknowledge the privacy notice and application details (box to be checked to indicate confirmation).</label>
                </div>
              </div>
              <p class="ml-3 mr-3">
                If the applicant is an organisation or comprises of more than one entity, then a person who has authority should complete this declaration and submit the application on behalf of the organisation or other entities.
              </p>
              <div class="col-md-10 col-xs-10 col-sm-10">
                <div class="row">
                  <div class="form-group col-md-6 col-xs-6">
                    <label class="control-label required" for="name">Name</label>
                    <input id="authoriserName" formControlName="authoriserName" title="Name" type="text" maxlength="25" placeholder="Name"
                           class="form-control" aria-required="true" />
                    <div class="text-danger"
                         [hidden]="declarationFgDetails.controls.authoriserName.valid || !declarationFgDetails.controls.authoriserName.touched">
                      <small *ngIf="declarationFgDetails.controls.authoriserName.hasError('required')">Name is required.</small>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-10 col-xs-10 col-sm-10">
                    <input type="radio" value="self" id="authOption" formControlName="authOption" />&nbsp;<span>I am the applicant</span><br />
                    <input type="radio" value="autho" id="authOption" formControlName="authOption" />&nbsp;<span>I am authorised to complete the declaration and submit the application on behalf of the applicant</span>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-6 col-xs-6">
                    <label class="control-label" for="position">Position</label>
                    <input id="position" formControlName="position" title="position" type="text" maxlength="50" placeholder="position"
                           class="form-control" aria-required="true" />

                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-6 col-xs-6">
                    <label class="control-label" for="organisation">Organisation</label>
                    <input id="organisation" formControlName="organisation" title="organisation" type="text" maxlength="100" placeholder="organisation"
                           class="form-control" aria-required="true" />

                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-6 col-sm-6">
                  <span *ngIf="!allowOffers" class="text-danger ml-3">BCT is not accepting any offers at the moment.</span>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="col md-12 clearfix py-3 card-footer">
            <div class="col-sm-6 col-md-12">
              <div class="row">
                <button class="btn btn-secondary" (click)="save();">Browse more Credits</button>&nbsp;
                <button class="btn btn-primary" (click)="submit();" [disabled]="!creditOfferFg.valid || !declarationFgDetails.valid || wantedCredits.length < 1 || !consentGiven">Submit Offer</button>&nbsp;
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-privacy  #pricacy></app-privacy>
  </div>

